module.exports = "<canvas #canvas></canvas>"